import { PermissionGuard } from '@/auth/guard';
import { OrionAccess, OrionModule, OrionSubmodule } from '@/types';
import {
  AddOnsTabPage,
  LegalEntityEditPage,
  OrganizationListPage,
  OrganizationEditPage,
  OrganizationTabsPage,
  LegalEntityCreatePage,
  OrganizationCreatePage,
  OrganizationUserEditPage,
  OrganizationOrderEditPage,
  OrganizationDomainEditPage,
  OrganizationUserCreatePage,
  OrganizationOrderCreateView,
  OrganizationContactEditPage,
  CancellationOrderDetailPage,
  OrganizationDomainCreatePage,
  OrganizationDocumentEditPage,
  OrganizationContactCreatePage,
  OrganizationOpportunitiesPage,
  OrganizationDocumentCreatePage,
  OrganizationConsumptionBagPage,
  OrganizationInformationEditPage,
  OrganizationBillingOrderNewPage,
  OrganizationSubscriptionEditPage,
  OrganizationSubscriptionOrderPage,
  OrganizationSubscriptionCreatePage,
  OrganizationSubscriptionAddonsPage,
  OrganizationSubscriptionBillingPage,
  OrganizationSubscriptionAddonsEditPage,
  OrganizationBillingOrderInformationPage,
  OrganizationSubscriptionInformationPage,
  OrganizationSubscriptionAddonsCreatePage,
} from './imports';

export const organizationRoutes = [
  {
    path: 'organizations',
    children: [
      {
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.ACCOUNT.COMPANY}
            access={OrionAccess.VIEW}
          >
            <OrganizationListPage />
          </PermissionGuard>
        ),
        index: true,
      },
      {
        path: 'list',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.ACCOUNT.COMPANY}
            access={OrionAccess.VIEW}
          >
            <OrganizationListPage />
          </PermissionGuard>
        ),
      },
      {
        path: ':id/edit',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.ACCOUNT.COMPANY}
            access={OrionAccess.UPDATE}
          >
            <OrganizationEditPage />
          </PermissionGuard>
        ),
      },
      {
        path: ':id/information/edit',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.ACCOUNT.COMPANY}
            access={OrionAccess.VIEW}
          >
            <OrganizationInformationEditPage />
          </PermissionGuard>
        ),
      },
      {
        path: ':id',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.ACCOUNT.COMPANY}
            access={OrionAccess.VIEW}
          >
            <OrganizationTabsPage />
          </PermissionGuard>
        ),
      },
      {
        path: ':id/contacts/new',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.ACCOUNT.COMPANY}
            access={OrionAccess.VIEW}
          >
            <OrganizationContactCreatePage />
          </PermissionGuard>
        ),
      },
      {
        path: ':id/contacts/:contact/edit',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.ACCOUNT.COMPANY}
            access={OrionAccess.VIEW}
          >
            <OrganizationContactEditPage />
          </PermissionGuard>
        ),
      },
      {
        path: ':id/digital-assets/domains/new',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.ACCOUNT.COMPANY}
            access={OrionAccess.VIEW}
          >
            <OrganizationDomainCreatePage />
          </PermissionGuard>
        ),
      },
      {
        path: ':id/digital-assets/domains/:domain/edit',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.ACCOUNT.COMPANY}
            access={OrionAccess.VIEW}
          >
            <OrganizationDomainEditPage />
          </PermissionGuard>
        ),
      },
      {
        path: ':id/orders/new',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.ACCOUNT.ORDER}
            access={OrionAccess.CREATE}
          >
            <OrganizationOrderCreateView />
          </PermissionGuard>
        ),
      },
      {
        path: ':id/orders/:order/edit',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.ACCOUNT.ORDER}
            access={OrionAccess.VIEW}
          >
            <OrganizationOrderEditPage />
          </PermissionGuard>
        ),
      },
      {
        path: ':id/billing/orders/new',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.ACCOUNT.ORDER}
            access={OrionAccess.CREATE}
          >
            <OrganizationBillingOrderNewPage />
          </PermissionGuard>
        ),
      },
      {
        path: ':id/billing/:orderId/information',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.ACCOUNT.ORDER}
            access={OrionAccess.UPDATE}
          >
            <OrganizationBillingOrderInformationPage />
          </PermissionGuard>
        ),
      },
      {
        path: ':id/documents/new',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.ACCOUNT.COMPANY}
            access={OrionAccess.VIEW}
          >
            <OrganizationDocumentCreatePage />
          </PermissionGuard>
        ),
      },
      {
        path: ':id/documents/:document/edit',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.ACCOUNT.COMPANY}
            access={OrionAccess.VIEW}
          >
            <OrganizationDocumentEditPage />
          </PermissionGuard>
        ),
      },
      {
        path: ':id/legal-entities/new',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.ACCOUNT.COMPANY}
            access={OrionAccess.VIEW}
          >
            <LegalEntityCreatePage />
          </PermissionGuard>
        ),
      },
      {
        path: ':id/legal-entities/:entity/edit',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.ACCOUNT.COMPANY}
            access={OrionAccess.VIEW}
          >
            <LegalEntityEditPage />
          </PermissionGuard>
        ),
      },
      {
        path: ':id/subscriptions/new',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.ACCOUNT.SUBSCRIPTION}
            access={OrionAccess.CREATE}
          >
            <OrganizationSubscriptionCreatePage />
          </PermissionGuard>
        ),
      },
      {
        path: ':id/subscriptions/:subscription/edit',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.ACCOUNT.SUBSCRIPTION}
            access={OrionAccess.UPDATE}
          >
            <OrganizationSubscriptionEditPage />
          </PermissionGuard>
        ),
      },
      {
        path: ':id/subscriptions/:subscription/information',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.ACCOUNT.COMPANY}
            access={OrionAccess.VIEW}
          >
            <OrganizationSubscriptionInformationPage />
          </PermissionGuard>
        ),
      },
      {
        path: ':id/subscriptions/:subscription/orders',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.ACCOUNT.SUBSCRIPTION}
            access={OrionAccess.VIEW}
          >
            <OrganizationSubscriptionOrderPage />
          </PermissionGuard>
        ),
      },
      {
        path: ':id/subscriptions/:subscription/addons',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.ACCOUNT.SUBSCRIPTION}
            access={OrionAccess.VIEW}
          >
            <OrganizationSubscriptionAddonsPage />
          </PermissionGuard>
        ),
      },
      {
        path: ':id/subscriptions/:subscription/addons/new',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.ACCOUNT.SUBSCRIPTION}
            access={OrionAccess.VIEW}
          >
            <OrganizationSubscriptionAddonsCreatePage />
          </PermissionGuard>
        ),
      },
      {
        path: ':id/subscriptions/:subscription/addons/:addon/edit',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.ACCOUNT.SUBSCRIPTION}
            access={OrionAccess.VIEW}
          >
            <OrganizationSubscriptionAddonsEditPage />
          </PermissionGuard>
        ),
      },
      {
        path: ':id/subscriptions/:subscription/addons/:addonId/:tab',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.ACCOUNT.SUBSCRIPTION}
            access={OrionAccess.VIEW}
          >
            <AddOnsTabPage />
          </PermissionGuard>
        ),
      },
      {
        path: ':id/subscriptions/:subscription/billing',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.ACCOUNT.SUBSCRIPTION}
            access={OrionAccess.VIEW}
          >
            <OrganizationSubscriptionBillingPage />
          </PermissionGuard>
        ),
      },
      {
        path: ':id/users/new',
        element: <OrganizationUserCreatePage />,
      },
      {
        path: ':id/users/:user/edit',
        element: <OrganizationUserEditPage />,
      },
      {
        path: ':id/balance/consumption-bags/:bagId',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.ACCOUNT.COMPANY}
            access={OrionAccess.VIEW}
          >
            <OrganizationConsumptionBagPage />
          </PermissionGuard>
        ),
      },
      {
        path: ':id/:tab',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.ACCOUNT.COMPANY}
            access={OrionAccess.VIEW}
          >
            <OrganizationTabsPage />
          </PermissionGuard>
        ),
      },
      {
        path: ':id/:tab/:subTab',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.ACCOUNT.COMPANY}
            access={OrionAccess.VIEW}
          >
            <OrganizationTabsPage />
          </PermissionGuard>
        ),
      },
      {
        path: 'new',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.ACCOUNT.COMPANY}
            access={OrionAccess.CREATE}
          >
            <OrganizationCreatePage />
          </PermissionGuard>
        ),
      },
      {
        path: ':organizationId/orders/cancellation/:cancellationId',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.ACCOUNT.ORDER}
            access={OrionAccess.VIEW}
          >
            <CancellationOrderDetailPage />
          </PermissionGuard>
        ),
      },
      {
        path: ':organizationId/cancellation-orders/:cancellationId',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.ACCOUNT.ORDER}
            access={OrionAccess.VIEW}
          >
            <CancellationOrderDetailPage />
          </PermissionGuard>
        ),
      },
      // Commented out: opportunities should be accessed through the tab system in OrganizationTabsPage
      // The URL should be /organizations/:id with tab parameter, not /organizations/:id/opportunities
      // {
      //   path: ':id/opportunities',
      //   element: (
      //     <PermissionGuard
      //       hasContent
      //       module={OrionModule.ACCOUNT}
      //       submodule={OrionSubmodule.ACCOUNT.COMPANY}
      //       access={OrionAccess.VIEW}
      //     >
      //       <OrganizationOpportunitiesPage />
      //     </PermissionGuard>
      //   ),
      // },
    ],
  },
];
